import WritingHome from "../writing/WritingHome";

export default function Writing() {
  return <WritingHome />;
}


